import {useContext} from 'react';
import {useQuery} from 'react-query';
import {paymentProAPI} from 'api';
import {verifyNrbToken} from 'api/routes/nrb';
import AppContext from 'components/App/AppContext';
import {Header} from 'components/Layouts/Header';
import {WidgetWrapper} from 'components/App/WidgetWrapper';
import {WidgetLayout} from 'components/App/WidgetLayout';
import {FacialVerificationContent} from './FacialVerificationContent';
import {FacialVerificationStyles} from './FacialVerificationStyles';

export const FacialVerification = () => {
    const {colors, params} = useContext(AppContext);
    const {token} = params;

    const tokenQuery = useQuery(
        ['nrb-facial-verification', token],
        async () => {
            const response = await paymentProAPI.get(verifyNrbToken(token));
            return response.data;
        },
        {
            enabled: !!token,
            retry: false,
            refetchOnWindowFocus: false,
        }
    );

    const merchant = tokenQuery.data?.data;

    return (
        <WidgetWrapper hideCloseBtn>
            <FacialVerificationStyles colors={colors}>
                <Header title="Facial Verification" />
                <div className="content">
                    <WidgetLayout currentQuery={tokenQuery} colors={colors}>
                        <FacialVerificationContent token={token} merchant={merchant} />
                    </WidgetLayout>
                </div>
            </FacialVerificationStyles>
        </WidgetWrapper>
    );
};
